import { Icon } from "@/lib/icons";

interface ExcelFilesErrorProps {
  message: string;
  retryLabel: string;
  onRetry: () => void;
}

export function ExcelFilesError({ message, retryLabel, onRetry }: ExcelFilesErrorProps) {
  return (
    <div className="mx-auto flex min-h-[320px] w-full max-w-7xl flex-col items-center justify-center gap-4 px-4 text-center">
      <Icon name="alertCircle" className="h-8 w-8 text-destructive" />
      <p className="max-w-lg text-sm text-muted-foreground">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="rounded-full bg-foreground px-4 py-2 text-xs font-semibold text-background"
      >
        {retryLabel}
      </button>
    </div>
  );
}
